import React from "react";
import { View } from "react-native";
import { Subheading, Title } from "react-native-paper";
import IconsYellowBanking from "../icons/icon-yellow-banking/IconsYellowBanking";
import { StackSpacing } from "../spacing";

interface ErrorBoundaryProps {}

interface Error {
  stack?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(_error: Error) {
    console.log("error", _error);
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _errorInfo: React.ErrorInfo) {}

  render() {
    if (this.state.hasError) {
      return (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <IconsYellowBanking name="notfound" size={200} />
          <Title>Oops ! Đã có lỗi xảy ra</Title>
          <Subheading>Dịch vụ không thể tiếp tục. Vui lòng thử lại</Subheading>
          <StackSpacing size="medium" />
        </View>
      );
    }
    return this.props.children;
  }
}
